import { DateTime, Duration } from "luxon";
import { AreaGeometryResponseDto } from "./area-geometry-response";
import { LocationUpdates } from "./location-update";

export class Job {
  id!: string;
  jobNumber!: string;
  vehicleType!: number;
  startAddress!: string;
  endAddress!: string;
  jobName?: string;
  jobTemplate?:string;
  jobColor? :string;
  planName?: string;
  startTime?: Duration;
  endTime?: Duration;
  startTerminalName?: string;
  endTerminalName?: string;
  startTerminalAddress?: string;
  endTerminalAddress?: string;
  startLatitude!: string;
  startLongitude!: string;
  endLatitude!: string;
  endLongitude!: string;
  distance?: string;
  duration?: Duration;
  distanceDisplay?: number;
  durationDisplay?: string;
  planId!: string;
  capacityType1!: number;
  capacityType2!: number;
  capacityType3?: number;
  qualifications!: string;
  createdAt!: DateTime;
  locationsCount!: number;
  locationUpdates?:LocationUpdates[];
  wayPoints!: number[][];
  isScheduled?: boolean;
  visible?: boolean;
  distributionAreaId?: string;
  distributionAreaName? : string;
  hasUpdate!:boolean;
  startTerminalCity?: string;
  startTerminalPostalCode?: string;
  endTerminalCity?: string;
  endTerminalPostalCode?: string;
  points?: AreaGeometryResponseDto;
  additionalData?:Record<string, string>;
}
